// src/pages/ChapterSix.js
// Chapter 6 — Spider Dance: Incey Wincey Spider
// New keys unlocked: G3 A3 B3 (to the LEFT of C)

import React from "react";
import ChapterTemplate from "../components/ChapterTemplate";

// Provided lines (expanded clusters, keeping G3 where specified)
const spiderLines = [
  ["C", "C", "C", "D", "E", "E"],
  ["E", "D", "C", "D", "E", "C"],
  ["E", "E", "F", "G", "G", "F", "E", "F", "G", "E"],
  ["G3", "G3", "C", "C", "C", "D", "E", "E", "E", "D"], // uses low G3
  ["C", "D", "E", "C"],
];

const spiderTarget = spiderLines.flat().filter(Boolean);

const ChapterSixStory = [
  { image: "/images/ChapterSix/Chp 6 Slide 1.png",
    text: "At the Treble Caves, silvery webs stretch across every corridor." },

  { image: "/images/ChapterSix/Chp 6 Slide 2.png",
    text: "Oh no—spiders are tangled in their own web and can’t wriggle free!" },

  { image: "/images/ChapterSix/Chp 6 Slide 3.png",
    text: "Play Incey Wincey Spider to help the spiders."  },

  { image: "/images/ChapterSix/Chp6 Slide 4.png",
    text: "New keys unlocked: look LEFT of C to find G3, A3, and B3 on the keyboard." },



];

export default function ChapterSix() {
  return (
    <ChapterTemplate
      chapterNumber={6}
      chapterTitle="Spider Dance — Incey Wincey Spider"
      sceneImageSrc="/images/ChapterSix/Chp 6 Melody Img .png"
      storySlides={ChapterSixStory}
      songTitle="Incey Wincey Spider"
      melodyLines={spiderLines}
      targetMelody={spiderTarget}
      companionsText={{
        wis: "Light steps! Keep climbs smooth and even—hit G3 cleanly.",
        pan: "Nice and steady—we’ll get them dancing free!",
      }}
      unlockNextChapterPath="/chapter-7"
      // Doron sleeps here
    />
  );
}
